import React, { Component } from "react";
import { Link } from "react-router-dom";
import KheshtiRug from "./rugTemplates/kheshtiRug";
import AfshanRug from "./rugTemplates/afshanRug";
import LachakToranjRug from "./rugTemplates/lachakToranjRug";
import ModernRug from "./rugTemplates/modernRug";

export default class RugsWishListSidebar extends Component {
  state = {
    widthPercent: "60%",
  };
  updateWidth = () => {
    const w = window.innerWidth;

    // فرمول خطی: از 60% تا 100% بین 400px و 1600px
    const minW = 400;
    const maxW = 1600;

    // محدود کردن بین min و max
    const clamped = Math.max(minW, Math.min(w, maxW));

    // محاسبه درصد: وقتی w=maxW → 60% ، وقتی w=minW → 100%
    var percent = 60 + ((maxW - clamped) / (maxW - minW)) * 60;
    if(percent > 100) {
      percent = 100;
    }

    this.setState({ widthPercent: `${percent}%` });
  };

  componentDidMount() {
    window.addEventListener("resize", this.updateWidth);
    this.updateWidth(); // initialize on mount
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWidth);
  }

  render() {
    const { widthPercent } = this.state;
    let wishList = [];
    this.props.wishList.map((rug, i) => {
      let key = rug.type + i;
      switch (rug.type) {
        case "lachak-toranj":
          wishList.push(
            <li className="check" key={key}>
              {/* <span> 23%</span> */}
              <LachakToranjRug
                background={rug.background}
                border={rug.border}
                corner={rug.corner}
                toranj={rug.toranj}
                show={true}
              />
            </li>
          );
          break;
        case "kheshti":
          wishList.push(
            <li className="check" key={key}>
              {/* <span> 23%</span> */}
              <KheshtiRug
                background={rug.background}
                tile={rug.tile}
                show={true}
              />
            </li>
          );
          break;
        case "modern":
          wishList.push(
            <li className="check" key={key}>
              {/* <span> 23%</span> */}
              <ModernRug
                background={rug.background}
                pattern={rug.pattern}
                show={true}
              />
            </li>
          );
          break;
        case "your_picture":
          wishList.push(
            <li className="check" key={key}>
              {/* <span> 23%</span> */}
              <ModernRug
                background={rug.background}
                pattern={rug.pattern}
                show={true}
              />
            </li>
          );
          break;
        default:
          wishList.push(
            <li className="check active" key={key}>
              {/* <span> 23%</span> */}
              <AfshanRug
                background={rug.background}
                border={rug.border}
                show={true}
              />
            </li>
          );
          break;
      }
      return "";
    });
    return (
      <div className="text-center favorites-list-normal-display" style={{ width: widthPercent }}>
        <ul className="relative">
          <li className={`btn ${this.props.wishList.length > 0 ? "btn-hide" : ""}`}>
            <button
              className={`btn-preview normal-add ${this.props.wishList.length > 0 ? "normal-add-hide" : ""}`}
              onClick={this.props.wishListHandler}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 12.75H6C5.59 12.75 5.25 12.41 5.25 12C5.25 11.59 5.59 11.25 6 11.25H18C18.41 11.25 18.75 11.59 18.75 12C18.75 12.41 18.41 12.75 18 12.75Z" fill="#353D57" />
                <path d="M12 18.75C11.59 18.75 11.25 18.41 11.25 18V6C11.25 5.59 11.59 5.25 12 5.25C12.41 5.25 12.75 5.59 12.75 6V18C12.75 18.41 12.41 18.75 12 18.75Z" fill="#353D57" />
              </svg>
              <span>
                {this.props.texts["addToWishList"]}
              </span>
            </button>
          </li>
          {/* this P tag : if className empty => show text else className hidden => none */}
          {/* {wishList.length === 0 && (
            <p className="empty">{this.props.texts["listIsEmpty"]} </p>
          )} */}

          {wishList}
        </ul>
        {this.props.wishList.length > 0 && (
          <Link
            to={{
              pathname: "/preview",
              state: { rugs: this.props.wishList },
            }}
          >
            <button className="btn-preview btn-left">
              <span>{this.props.texts["preview"]}</span>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.99953 13.78C9.87286 13.78 9.7462 13.7333 9.6462 13.6333L5.29953 9.28668C4.59286 8.58001 4.59286 7.42001 5.29953 6.71335L9.6462 2.36668C9.83953 2.17335 10.1595 2.17335 10.3529 2.36668C10.5462 2.56001 10.5462 2.88001 10.3529 3.07335L6.0062 7.42001C5.6862 7.74001 5.6862 8.26001 6.0062 8.58001L10.3529 12.9267C10.5462 13.12 10.5462 13.44 10.3529 13.6333C10.2529 13.7267 10.1262 13.78 9.99953 13.78Z" fill="white" />
              </svg>
            </button>
          </Link>
        )}
      </div>
    );
  }
}

{/* <p className="mt-3"> {this.props.texts["wishList"]} </p>
        <p className="p-3" style={{ color: "#727d93", fontSize: "13px" }}>
          {this.props.texts["wishListText"]}{" "}
        </p> */}

{/* {this.props.wishList.length < 1 && (
          <>
            <button className="btn-preview" disabled>
              <span>{this.props.texts["preview"]}</span>
            </button>
            <p style={{ fontSize: 10 }}>
              {this.props.texts["previewEmptyHelpText"]}
            </p>
          </>
        )} */}
